module.exports = __webpack_public_path__ + "static/media/swirge-500x263.f390fdbc.png";